/* jshint ignore:start */
import React, { useState } from "react";
import Card from "../shared/UI/Card";
import "./ImageList.css";
import Modal from "../shared/UI/Modal";

const ImageList = (props) => {
  const [modal, setmodal] = useState(false);
  const [image, setimage] = useState();

  const showModal = (img) => {
    setimage(img);
      document.documentElement.style.overflowY = "hidden";
    setmodal(true);
  };

  const closeModal = () => {
    document.documentElement.style.overflowY = "visible";
    setmodal(false);
  };

  const frames = props.imageList.map((m) => {
    return (
        <Card key={m.id}>
          <img
            src={m.urls.small}
            className="frame"
            alt="cars"
            onClick={() => showModal(m.urls.small)}
          />
        </Card>
    );
  });

  return (
    <React.Fragment>
      <div className="row">
        {frames}
        {props.count === 0 && (
          <div class="col-sm-12 col-md-12 col-lg-12 col-12 alert-height">
            <div class="alert alert-danger text-center">
              <strong>No Images found</strong>
            </div>
          </div>
        )}
      </div>
      {modal && <Modal image={image} show={modal} onCancel={closeModal} />}
    </React.Fragment>
  );
};

export default ImageList;
